import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_POLYGON_REGION, GET_POLYGON_REGION_SUCCESS, GET_POLYGON_REGION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import debounce from 'lodash/debounce';

function* getPolygonRegion({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/benefit-type/airport-transfer/serviceable-zones/${payload?.data?.vendorId}`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_POLYGON_REGION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_POLYGON_REGION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_POLYGON_REGION_ERROR, payload: error });
  }
}

export function* watchGetPolygonRegion() {
  yield takeEvery(GET_POLYGON_REGION, getPolygonRegion);
}

function* getPolygonRegionSaga() {
  yield all([fork(watchGetPolygonRegion)]);
}

export default getPolygonRegionSaga;
